export default __webpack_public_path__ + "static/media/Information.53a42d03.svg";